import React from 'react'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import logo from '../components/images/6_Ayur copy.webp'
import { NavLink, useLocation } from "react-router-dom";
import { MdCall } from "react-icons/md";


export default function Tern_nav() {
    const location = useLocation();
    
        const isTreatmentActive =
        location.pathname.startsWith("/treatment") ||
        location.pathname.startsWith("/postnatal") ||
        location.pathname.startsWith("/rejuvenation") ||
        location.pathname.startsWith("/hair_treatment") ||
        location.pathname.startsWith("/lifestyle_yoga") ||
        location.pathname.startsWith("/soundarya_kalpa");
  return (
    <section className="container-fluid about-main-section">
      {/* Overlay */}
      <div className="about-main-overlay"></div>

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark about-navbar">
        <div className="container">

          {/* Logo */}
           <a className="navbar-brand" href="#"><span><img src={logo} alt="logo" className="brand-logo bg_new"/><span  className=" logo_txt mt-5" ></span></span>
          </a>

          {/* Toggle */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#aboutNavbar"
            aria-controls="aboutNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menu */}
          <div className="collapse navbar-collapse justify-content-center" id="aboutNavbar">

            <ul className="navbar-nav align-items-lg-center gap-lg-3 text-center">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Home</b></NavLink>
              </li>

              <li className="nav-item">
              
                <NavLink  className="nav_Active" to="/ourstory" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Our Story</b></NavLink>
              </li>

               <li className="nav-item dropdown">
  <NavLink
    to="/treatment"
    className="nav-link dropdown-toggle"
    data-bs-toggle="dropdown"
    style={() => ({
      color: isTreatmentActive ? "orange" : "white"
    })}
  >
    <b>Treatments</b>
  </NavLink>

  <ul className="dropdown-menu">
    <li>
      <NavLink
        to="/treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        All Treatments
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/postnatal"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Postnatal Care
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/rejuvenation"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Rejuvenation Therapy
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/hair_treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Hair Treatment
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/lifestyle_yoga"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Life Style Guidance & Yoga
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/soundarya_kalpa"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Soundarya Kalpa
      </NavLink>
    </li>
  </ul>
</li>


                <li className="nav-item">
                  <NavLink className="nav_Active" to="/contact" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>contact</b></NavLink>
              </li>
             
            </ul>
          </div>

        </div>
        <div className="d-none d-lg-flex align-items-center gap-3 ms-auto">
<span className="phone-inline">
  <MdCall /> <b>+91 7736 111 482</b>
</span>


  <a
    href="https://wa.me/917736111482?text=Hello%20I%20would%20like%20to%20know%20more%20about%20your%20treatments"
    target="_blank"
    rel="noopener noreferrer"
    className="messenger-btn"
    style={{ backgroundColor: "#006400", textDecoration: "none" }}
  >
    WhatsApp
  </a>
</div>

      </nav>

      {/* Center Content */}
      <div className="about-main-content">
        <h1 className="head-font" style={{color:'#f7f0d3'}}>Terms & Conditions</h1>
        
        
      </div>
    </section>
  )
}
